import instance from "@/utils/require.js"

// 产品产测指令列表
export function apiProductFactoryCommandList(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/list",
		method: "post",
		data
	})
}

export function apiProductFactoryCommandSave(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/save",
		method: "post",
		data
	})
}
export function apiProductFactoryCommandEdit(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/edit",
		method: "post",
		data
	})
}

export function apiProductFactoryCommandDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/delete",
		method: "post",
		data
	})
}

export function apiProductFactoryCommandDeleteArray(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/deleteArray",
		method: "post",
		data
	})
}

export function apiProductFactoryCommandCopy(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/copy",
		method: "post",
		data
	})
}
//复制产品最后一个固件版本的指令
export function apiProductFactoryFirmwareCommandCopy(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/copyFactoryFirmwareCommand",
		method: "post",
		data
	})
}

export function apiProductFactoryCommandMoveTo(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/move_to",
		method: "post",
		data
	})
}
export function apiProductFactoryCommandDragSort(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/drag_sort",
		method: "post",
		data
	})
}

export function apiProductFactoryCommandSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/search",
		method: "post",
		data
	})
}

export function apiProductFactoryCommandMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/move_up",
		method: "post",
		data
	})
}

export function apiProductFactoryCommandMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/product_factory_command/move_down",
		method: "post",
		data
	})
}

export function apiProductList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/list",
		method: "post",
		data
	})
}

export function listByFactoryCommandsNameIsNotNull(data = {}) {
	return instance({
		url: "/aim/api/v3/product/listByFactoryCommandsNameIsNotNull",
		method: "post",
		data
	})
}
